export default "__VITE_ASSET__CpwMz4g9__"